import { render, staticRenderFns } from "./cancelRules.vue?vue&type=template&id=7b1b3528&"
import script from "./cancelRules.vue?vue&type=script&lang=js&"
export * from "./cancelRules.vue?vue&type=script&lang=js&"
import style0 from "./cancelRules.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports